import { ref, computed, inject } from 'vue'
import { useClientStore } from '@/stores/ClientStore'
import { useConsent } from '@/vendors/consent'
import { whenever } from '@/utils/utils'

const metaSymbol = Symbol()

export const createMeta = {
  install: app => {
    const { getClient } = useClientStore()

    const { client } = getClient()

    const version = process.env.VUE_APP_FACEBOOK_VERSION || 'v23.0'
    const app_id = client.value.frontend_integrations.fb_appid

    const fb = ref()

    const loadFacebook = () => {
      if (fb.value || !app_id) return

      const d = document
      const s = 'script'
      const id = 'facebook-jssdk'

      const fjs = d.getElementsByTagName(s)[0]

      if (d.getElementById(id)) return

      const js = d.createElement(s)
      js.id = id
      js.src = 'https://connect.facebook.net/en_US/sdk.js'
      fjs.parentNode.insertBefore(js, fjs)

      window.fbAsyncInit = () => {
        try {
          fb.value = window.FB
          fb.value.init({ appId: app_id, autoLogAppEvents: true, xfbml: true, version })
        } catch (e) {
          throw e
        }
      }
    }

    app.provide(metaSymbol, {
      fb,
      loadFacebook
    })
  }
}

export const useMeta = () => {
  const { fb, loadFacebook } = inject(metaSymbol)

  const { isVendorAllowed } = useConsent()

  const isAllowed = computed(() => isVendorAllowed('facebook'))

  whenever(isAllowed, () => loadFacebook(), { immediate: true, once: true })

  return {
    fb: computed(() => isAllowed.value ? fb.value : null)
  }
}